import { call, put, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice } from 'Modules'
import { TYPE_ORIGIN_ADDRESS } from 'Constants/Address.constants'
import { MIN_FIND_LENGTH } from 'Constants/Global'
import { addressApi, addressNS, addressSlice } from 'Pages/advertisement'

function* getAddressSaga(action: addressNS.getAddress) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const query = action.payload?.query ?? ''
		if (query?.length > MIN_FIND_LENGTH) {
			const res = yield* call(addressApi.getAddress, {
				origin: TYPE_ORIGIN_ADDRESS.ORD_TARGET_GEO,
				query,
			})
			yield* put(
				addressSlice.actions.setAddress({
					entries: res,
				})
			)
		}
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* addressSaga() {
	yield* takeLatest(addressSlice.actions.getAddress.type, getAddressSaga)
}
